const DEBUG_LOGIN_HOSTS = ['localhost', 'ku-aao.test.mmj.ne.jp']

export function isDebugLoginHost(): boolean {
  return DEBUG_LOGIN_HOSTS.includes(window.location.hostname.toLowerCase())
}
